import React, { FC } from 'react';
import translate from '@translate';
import { useNavigate } from 'react-router-dom';
import { AddIcon, ReloadIcon } from 'src/components/SkladonIcon/Icons';
import TopBlockAdmin from '../AdminContainer/TopBlock';

type TopBlockProps = {
    reloadList: () => void;
    permissionCreate: boolean;
};
const TopBlock: FC<TopBlockProps> = (props) => {
    const navigate = useNavigate();

    const handleNew = () => {
        navigate(`/admin/email_templates/new`);
    };

    return (
        <TopBlockAdmin
            actions={[
                {
                    onClick: props.reloadList,
                    icon: <ReloadIcon />,
                    tooltip: translate('emailTemplates.synchronizeTable'),
                    variant: 'outlined',
                },
                {
                    label: translate('emailTemplates.createNewEmailTemplate'),
                    onClick: handleNew,
                    icon: <AddIcon />,
                    hidden: !props.permissionCreate,
                },
            ]}
        />
    );
};

export default TopBlock;
